/**
 * Internal dependencies
 */
import {
    CURRENT_CLOUD_HOSTING_RECEIVE,
    CURRENT_CLOUD_HOSTING_REQUEST,
    CURRENT_CLOUD_HOSTING_REQUEST_SUCCESS,
    CURRENT_CLOUD_HOSTING_REQUEST_FAILURE,
} from 'state/action-types';

import cscom from 'lib/customer-site-api';
import {getCurrentCloudHosting, requestingCurrentCloudHosting} from 'state/current-cloud-hosting/selectors';

/**
 * [description]
 *
 * @param  {[type]} hosting [description]
 * @return {[type]}         [description]
 */
export const setCurrentCloudHosting = (hosting) => {
    return {
        type: CURRENT_CLOUD_HOSTING_RECEIVE,
    };
};

/**
 * [description]
 *
 * @param  {[type]} ) [description]
 * @return {[type]}   [description]
 */
export const requestCurrentCloudHosting  = () => (dispatch) => {
    dispatch({
        type: CURRENT_CLOUD_HOSTING_REQUEST,
    });

    return cscom
        .currentCloudHosting()
        .list()
        .then((hosting) => {
            dispatch({
                type: CURRENT_CLOUD_HOSTING_REQUEST_SUCCESS,
            });
            dispatch({
                type: CURRENT_CLOUD_HOSTING_RECEIVE,
                payload: {
                    hosting,
                },
            });
            return hosting;
        })
        .catch((error) => {
            if (error == 'Error: Not Found') {
                dispatch({
                    type: CURRENT_CLOUD_HOSTING_REQUEST_SUCCESS,
                });
                return;
            }
            dispatch({
                type: CURRENT_CLOUD_HOSTING_REQUEST_FAILURE,
                error,
            });
        });
};

/**
 * [description]
 * 
 * @param  {...[type]} props) [description]
 * @return {[type]}           [description]
 */
export const requestCurrentCloudHostingIfNotRequested = (...props) => async (dispatch, getState) => {
    
    const currentCloudHosting = getCurrentCloudHosting(getState());
    const requesting = requestingCurrentCloudHosting(getState());

    if (!currentCloudHosting && requesting == false) {
        return dispatch(requestCurrentCloudHosting(...props))
    }

    return currentCloudHosting;
}
